module.exports = __webpack_public_path__ + "img/refunding.0617c6e5.png";